import { AppHandler } from '../work-modules/018/AppHandler';

document.addEventListener('DOMContentLoaded', async () => {
  const webGlCanvas = document.getElementById("webgl-canvas") as HTMLCanvasElement;

  if (webGlCanvas) {
    const appHandler = new AppHandler(webGlCanvas);
    try {
      await appHandler.initialize();
    } catch (error) {
      console.error("Failed to initialize application:", error);
    }
  }
});